import { AxiosInstance } from 'axios'

import { InjectionKey } from '@vue/composition-api'

export class LanguageApi {
  constructor(private language: AxiosInstance, private uri: string) {}

  private path(path: string): string {
    return this.uri + path
  }

  GetLanguages(): any {
    return this.language
      .get(this.path(`/transcripts/languages`))
      .then(response => {
        return response?.data || []
      })
  }
}
export type Language = Array<Partial<Languages>>

export type Languages = Partial<{
  label: string
  value: string
}>

export const LanguageApiKey: InjectionKey<LanguageApi> = Symbol()
